import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ExcelManagementFacade } from '../../../../redux-store';
import { TExcelContext } from '@monorepo/types';

@Component({
  selector: 'monorepo-upload-modal',
  templateUrl: './upload-modal.component.html',
  styleUrls: ['./upload-modal.component.scss'],
})
export class UploadModalComponent {
  @Input() excelContext!: TExcelContext;

  constructor(private modalController: ModalController, private excelManagementFacade: ExcelManagementFacade) {}

  uploadFile(file: File) {
    this.modalController.dismiss();
    this.excelManagementFacade.uploadExcel(file, this.excelContext);
  }

  downloadFile() {
    this.excelManagementFacade.downloadSampleTemplate(this.excelContext);
  }

  closeModal() {
    this.modalController.dismiss();
  }
}
